import styled from 'styled-components'

export const Row = styled.div`
  display: grid;
  grid-column-gap: 24px;
  grid-template-columns: 1fr 1fr;
`
